import config from "../config";

const REGION_DOMAIN_RULES = [
  { region: "india", domains: ["thurent.in"] },
  { region: "usa", domains: ["thurent.us"] },
];

const normalizeHost = (value) => {
  if (!value) {
    return "";
  }

  try {
    return new URL(value).hostname.toLowerCase().replace(/\.$/, "");
  } catch {
    return String(value).toLowerCase().replace(/\.$/, "");
  }
};

const matchesDomain = (hostname, domain) =>
  hostname === domain || hostname.endsWith(`.${domain}`);

const detectRegionFromHost = (host) => {
  const normalizedHost = normalizeHost(host);

  if (!normalizedHost) {
    return null;
  }

  const matchedRule = REGION_DOMAIN_RULES.find(({ domains }) =>
    domains.some((domain) => matchesDomain(normalizedHost, domain))
  );

  return matchedRule ? matchedRule.region : null;
};

const getDefaultRegion = () => Object.keys(config.contactInfo || {})[0] || "india";

export const getCurrentRegion = () => {
  if (typeof window !== "undefined") {
    const currentHostname = detectRegionFromHost(window.location.hostname);
    if (currentHostname) {
      return currentHostname;
    }
  }

  const apiBaseRegion = detectRegionFromHost(config.API_BASE_URL);
  if (apiBaseRegion) {
    return apiBaseRegion;
  }

  return getDefaultRegion();
};

export const getRegionContactInfo = () => {
  const currentRegion = getCurrentRegion();
  const regionContactInfo = config.contactInfo?.[currentRegion];

  if (regionContactInfo) {
    return regionContactInfo;
  }

  const fallbackRegion = getDefaultRegion();
  return config.contactInfo?.[fallbackRegion] || null;
};

export const getCurrentWebsiteUrl = () => {
  const currentRegion = getCurrentRegion();
  const domain = currentRegion === "usa" ? "thurent.us" : "thurent.in";

  return `https://${domain}/`;
};

export const formatRegionAddress = (address) =>
  address
    ? address.split("\n").map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))
    : null;
